import { ViewChild, Input, Component, OnInit, ElementRef } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { Router } from '@angular/router';

import Utils from '../shared/utility';

import { trigger, animate, transition, style } from '@angular/animations';
import { debounce, debounceTime } from 'rxjs/operators';

import Util from '../shared/utility';


import { MatDialog } from '@angular/material/dialog';
import { CostProjectionDetailsComponent } from '../shared/modal/cost-projection-details/cost-projection-details.component'
import { CostOfWaitingComponent } from '../shared/modal/cost-of-waiting/cost-of-waiting.component'
import { FundingSourceComponent } from '../shared/modal/funding-source/funding-source.component';
import { AdjustRatesComponent } from '../shared/modal/adjust-rates-of-return/adjust-rates.component';

import { investmentGrowthDecumation } from '../dummy-data/data'
import { Subject } from 'rxjs-compat';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Advisor } from 'app/models/advisor';

@Component({
  selector: 'app-healthcare-express',
  templateUrl: './healthcare-express.component.html',
  styleUrls: ['./healthcare-express.component.css'],
  host: {
    '[@fadeInAnimation]': ''
  },
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate('1000ms', style({
          opacity: 1,
        }))
      ]),
    ])
  ]
})
export class HealthcareExpressComponent implements OnInit {
  public pHospMessage: string = "There is no premium cost for Medicare Part A, which covers hospitalization. The premium for Medicare Part B covers doctor visits and test costs.";
  public pDrug: string = "The premium for Medicare Part D covers prescription drug costs.";
  public pSupp: string = "The premium for MediGap covers coinsurance, co-payment and deductible out-of-pocket costs which are not covered by Medicare Parts A and B. MediGap coverage can no longer be purchased to cover Part D prescription drug costs. This coverage is provided through private insurers.";
  public pDental: string = "The premium for dental insurance will cover the standard dental care coverage. Medicare does not cover any routine dental or denture costs.";

  public oopHosp: string = "This represents the annual out-of-pocket costs for doctor visits, tests, etc. which are not covered by the Medicare Part B premium. These costs will be higher if you do not buy MediGap insurance.";
  public oopDrug: string = "This represents the annual out-of-pocket costs which will not be covered by the Medicare Part D premium. This can include the costs which must be paid by an individual if their annual drug costs are between $2750 and $4750 (the 2013 “donut hole” amounts.)";
  public oopHearing: string = "This represents the annual out-of-pocket costs for hearing and vision tests, eyeglasses, etc. which are not covered by Medicare Part B.";
  public oopDental: string = "This represents the annual out-of-pocket costs for dental care, dentures, etc. which are not covered by the standard Dental Insurance policy.";
  public fsMessage: string = "Add any expected income which is earmarked to healthcare cost funding in the inputs below. Values entered will reduce projected unfunded costs, and the investment solution to address that amount.";
  //public ssMMessage: string = "Medicare Part B premiums and Medicare Parts B and D surcharges are automatically deducted out of one’s Social Security benefit.";
  public investmentSolnMessage: string = "Select up to three unique rates of return throughout the client’s lifetime to produce multiple savings solutions for unfounded future health expenses: a one time investment, annual payments, or weekly payments.";
  public ssMMessage: string = "By law, Medicare deducts the cost of Medicare Part B, as well as potential means testing surcharges on Parts B and D, from Social Security checks.";

  public premiumsInfo: string = "Standard, baseline costs for health coverage, paid either to the government, or the insurance provider.";
  public additionalOOPInfo: string = "Costs not covered by premiums. May include copays, deductibles, and more.";

  public investmentToFundInfo: string = 'Based on rates of return indicated at bottom-center of this page, the one-time lumpsum investment required today to cover projected retirement health costs, after additional funding sources are accounted for.';
  public estimatedFutureInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in future dollars (otherwise known as "future value")';
  public estimatedTodayInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in today`s dollars (otherwise known as "net present value")';

  public futureCostMessage: string = `Selecting "Today's Dollars" will show costs in the net present value, assuming an annual inflation rate of 3%. Selecting "Future Dollars" will show projected future costs in the given year.`;

  public hcData: any;
  public hcDataV2: any;
  public p1CostsV2: any;
  public p2CostsV2: any;
  public tempCostsV2: any;
  public spouseHCOptionsVisible: boolean = false;

  public beginningBalance: 0;

  public tempHCData: any;
  public error: string;

  public client: any;

  public projectedFutureLifetimeCosts: number;
  public totalSocialSecurity: number = 0;
  public totalInvestment: number = 0;
  public totalRemainingGap: number = 0;
  public ssRemaining: number = 0;


  public currentRemainingTotal: number = 0;

  public additionalFunds: number = 0;

  public fundingItems: any[] = [];
  public partnerActive: boolean = false;
  public applyHealthcareToSpouse: boolean = false;

  public coverageTotal: number = 0;
  public premiumCoverageTotal: number = 0;
  public outOfPocketCoverageTotal: number = 0;
  public FrmPV: number = 1;
  public spouseHC: number = 0;
  public investmentOptionValue: 0;

  public lineChartData: any[];
  public pieChartData: any[];
  public barChartData: any[];
  public rOROptions: any[] = [
    {
      text: 'Option 1',
      value: '6%'
    },
    {
      text: 'Option 2',
      value: '7%',
      selected: true
    },
    {
      text: 'Option 3',
      value: '8%'
    }
  ];
  phaseOneYear: string = '2030';
  phaseTwoYear: string = '2040';

  public fundingSource: any;
  public startAge: any;
  public endAge: any;
  public inflationRate: any;
  public annContribution: any;
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;

  showTable: boolean;
  annuallyWeeklyTtlYear: number;

  spouseProfileInfo: FormGroup;
  profileInfo: FormGroup;

  selectionDropDown: FormGroup;

  getClientProfileInfo: any;
  getClientHealthInfo: any;
  getSpouseProfileInfo: any;
  getSpouseHealthInfo: any;
  private advisor: Advisor;

  minLEAge;
  maxLEAge;

  dropDownSelectedIndexAnnually: number = 0;
  dropDownSelectedIndexWeekly: number = 0;
  investmentDescription: string;
  bodyCardSelectedIndexAnnually: number;
  bodyCardSelectedIndexWeekly: number;

  @ViewChild('FundingSource') fundingSourceInput: any;
  @ViewChild('AnnContribution') annContributionInput: any;
  @ViewChild('StartAge') startAgeInput: any;
  @ViewChild('EndAge') endAgeInput: any;
  @ViewChild('InflationRate') inflationRateInput: any;

  @ViewChild('rate2') rate2: any;

  @ViewChild('totalRemainingGapEl') totalRemainingGapEl: ElementRef;
  @ViewChild('totalFutureEstimatedCostsEl') totalFutureEstimatedCostsEl: ElementRef;
  @ViewChild('totalEstimatedCostsEl') totalEstimatedCostsEl: ElementRef;

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;

  @ViewChild('annualEl') annualEl: ElementRef;
  @ViewChild('weeklyEl') weeklyEl: ElementRef;


  @ViewChild('pcheck') pcheck: ElementRef;
  @ViewChild('oopcheck') oopcheck: ElementRef;

  @ViewChild('hdt') hdt: ElementRef;
  @ViewChild('pd') pd: ElementRef;
  @ViewChild('si') si: ElementRef;
  @ViewChild('di') di: ElementRef;
  @ViewChild('hd') hd: ElementRef;
  @ViewChild('pdrg') pdrg: ElementRef;
  @ViewChild('hvc') hvc: ElementRef;
  @ViewChild('dins') dins: ElementRef;
  @Input() percentageFormatting: (value: number) => any;
  investmentGrowthDecumation: any[];

  public premiumExpenses: any = {
    partB: true,
    partD: true,
    medigap: true,
    dental: true
  };

  public outOfPocketExpenses: any = {
    hospitalization: true,
    docsTests: true,
    rx: true,
    dental: true,
    hearingServices: true,
    vision: true,
    commercial: true
  };

  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: false,
    timeline: false,
    curve: false,
    tooltipDisabled: false,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    //'#c0d465', '#c7d976', '#cede87', '#d5e298', '#dce7a9', '#e3ecba', '#eaf0cb'
    colorScheme: { domain: ['#bad054', '#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    yAxisLabel: 'Population',
    roundEdges: false,
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }

  public barVerticalStackedChartColorHolder = {
    //domain: ['#3385C5', '#E58931', '#20a59f']
    // domain: ['#5270ad', '#487879', '#63a49e']
    domain: ['#63a49e', '#5270ad','#487879']
  };
  
  public barVerticalStackedChartOption = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,

    showYAxisLabel: false,


    roundEdges: false,
    colorScheme: {
      //domain: ['#3385C5', '#E58931', '#20a59f']
      domain: ['#63a49e', '#5270ad','#487879']
    },
    autoScale: true

  };
  imgSrc: string;
  isSrcReport: string;
 public selected: any = {
   isoneTimeInvestmentSelect: false,
   isannuallyRecurringInvestmentSelect: false,
   isweeklyRecurringInvestmentSelect: false,
 }

 eventsSubject: Subject<void> = new Subject<void>();

 emitEventToChild() {
  this.eventsSubject.next();
}
public allStates: any[] = Utils.allStates;

public magiBrackets: any[]

magiBracketOneMin: number;
magiBracketOneMax: number;
magiBracketTwoMin: number;
magiBracketTwoMax: number;
magiBracketThreeMin: number;
magiBracketThreeMax: number;
magiBracketFourMin: number;
magiBracketFourMax: number;
magiBracketFiveMin: number;
magiBracketFiveMax: number;
magiBracketSixMin: number;
magiBracketSixMax: string;
currentIncome: number;

  constructor(private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService, public dialog: MatDialog) {
    this.globalService.featFunding = JSON.parse(localStorage.getItem('featFunding'));

    this.imgSrc = '../../../assets/icons/hc_express.svg';
    this.isSrcReport = "healthCareExpressReport";
    
    this.getClientProfileInfo = this.router.getCurrentNavigation().extras.state.profileInfo;
    this.getClientHealthInfo = this.router.getCurrentNavigation().extras.state.healthInfo;

    console.log('this.getClientProfileInfo', this.getClientProfileInfo);
    this.getSpouseProfileInfo = this.router.getCurrentNavigation().extras.state.spouseProfileInfo;
    this.getSpouseHealthInfo = this.router.getCurrentNavigation().extras.state.spouseHealthInfo;

    this.selected.isoneTimeInvestmentSelect = true;
    
    localStorage.setItem('isCreateClient', "False");
    Object.assign(this, { investmentGrowthDecumation });
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient();
      }
    });

    this.ssClientAgeChanged.pipe(
      debounceTime(1500))
      .subscribe(model => {
          //this.magi = 100;
          this.ssClientAge = this.validateSSAge(Number(this.ssClientAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
          this.getMMTData();
      });

  this.ssSpouseAgeChanged.pipe(
      debounceTime(1500))
      .subscribe(model => {
          //this.magi = 100;
          this.ssSpouseAge = this.validateSSAge(Number(this.ssSpouseAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
          this.getMMTData();
      });
  }

  validateSSAge(age, survivor) {
    if (!survivor) {
        if (age < 62)
            return '62';
        if (age > 70)
            return '70';
    } else {
        if (age < 60)
            return '60';
        if (age > 70)
            return '70';
    }
    return age.toString();
}

  returnedFundingSource(data){
    console.log('retured data to HC page', data);

    for (var item in data){

      this.handleNewFundingItem(data[item].fundingSource, data[item].annualContribution, 
        data[item].startYear, data[item].endYear, data[item].inflationRate/100);
    }
  }

  generateLineChartData(data: any) {   

    if (this.hcDataV2) {



      let currentYear = new Date().getFullYear();
      let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;

      this.lineChartData = [
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({ 'name': (retirementYear + i).toString(), 'value': this.formatNumber(expense) });
          return acc;

        }, { name: 'Cost', series: []}),
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear +1+ i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'Cost', series: []})];
        
    }
  }

  generatePieChartData() {
    // tempTotal =  tempTotal + this.fundingItems.reduce((item, acc) => { console.log(acc); return acc + item.remainingUnfunded}, 0);
    var tempTotal = this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }
    console.log('pie', this.fundingItems);
    
    this.pieChartData = [
      { "name": "Unfunded", "value": tempTotal },
      { "name": "Medicare Deduction from Social Security", "value": this.totalSocialSecurity }
    ]

    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount }) });
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }

  generateBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = (this.hcDataV2.Illustrations.length >= 3) ? this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0 : 0;
    this.cowValues.five = (this.hcDataV2.Illustrations.length >= 5) ? this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0 : 0;

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": (this.hcDataV2.Illustrations.length >= 3) ? this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0) : 0
      },
      {
        "name": "5 Years",
        "value": (this.hcDataV2.Illustrations.length >= 5) ? this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0) : 0
      }
    ]
  }
 
  
  generateInvestGrowthBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.five = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0;
    

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)
      },
      {
        "name": "5 Years",
        "value": this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)
      }
    ]
  }

  objAdjustRates;// = '';
  reDirectModal(modalName): void {
    if (modalName == 'costExplained') {
      const dialogRef = this.dialog.open(CostProjectionDetailsComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.hcDataV2, partnerActive: this.partnerActive, FrmPV: this.FrmPV }
      });
    }
    if (modalName == 'costOfWaiting') {
      const dialogRef = this.dialog.open(CostOfWaitingComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.hcDataV2 }
      });
    }
    if (modalName == 'addFundingSource') {
      const dialogRef = this.dialog.open(FundingSourceComponent, {
        width: '1000px',
        height: '700px',
        data: {hcDataV2: this.hcDataV2, modalName: modalName }
      });
    }
    if (modalName == 'adjustRates') {
      const dialogRef = this.dialog.open(AdjustRatesComponent, {
       /*  width: '1000px',
        height: '700px', */
        data: {client: this.client, obj: this.objAdjustRates, modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{
        //recalc illustration page here with new ROR values
        //console.log('from close', result);
        if(result){
          this.objAdjustRates = result;
          this.getHCData(this.client, this.partnerActive);
        }
      });
    }

  }
  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  ngOnInit() {
    
    this.profileInfo = new FormGroup({
      privateHealthInsurance: new FormControl(),
      preRetirementCoverageType: new FormControl(),
      inRetirementCoverageType: new FormControl(),

      //Traditional Medicare (TM)
      medicarePartB: new FormControl(),
      medicarePartD: new FormControl(),
      supplemental: new FormControl(),

      //Medicare Adv HMO
      medicareAdvHMO: new FormControl(),

      //Medicare Adv PPO
      medicareAdvPPO: new FormControl(),

      //always avail
      dental: new FormControl(),
      hospitalDocsTestsOOP: new FormControl(),
      prescriptionDrugsOOP: new FormControl(),  
      hearingVisionOOP: new FormControl(),    
      dentalOOP: new FormControl(),
      runReportWithSpouse: new FormControl(),
      maritalStatus: new FormControl()
    });

    this.selectionDropDown = new FormGroup({
      retirementAge: new FormControl('65', [Validators.required]),
      retirementState: new FormControl('NA', [Validators.required]),
      lifeExpectancy: new FormControl('87', [Validators.required]),
      magiBracket: new FormControl('1', [Validators.required]),  
      coverage: new FormControl('PPO', [Validators.required])
    });
    this.getMMTBracket('firstTimeLoad');
    this.getAdvisorData();
  }

  getMMTBracket(scenario) {
    let includePartner = this.getClientProfileInfo.maritalStatus ? 'true' : 'false';
        this.globalService.getMMTBracket(includePartner)
            .subscribe(
                data => {
                  console.log('getMMTData');
                  console.log(data);
                  this.getMAGIBracket(data, scenario);
                },
                error => console.log(error));
  }

  getMAGIBracket(data, scenario) {
    this.magiBracketOneMin = data.Bracket1 ? data.Bracket1: 0;
    this.magiBracketOneMax = data.Bracket2 ? data.Bracket2 - 1 : 0;

    this.magiBracketTwoMin = data.Bracket2 ? data.Bracket2 : 0;
    this.magiBracketTwoMax = data.Bracket3 ? data.Bracket3 - 1 : 0;

    this.magiBracketThreeMin = data.Bracket3 ? data.Bracket3 : 0;
    this.magiBracketThreeMax = data.Bracket4 ? data.Bracket4 - 1 : 0;

    this.magiBracketFourMin = data.Bracket4 ? data.Bracket4 : 0;
    this.magiBracketFourMax = data.Bracket5 ? data.Bracket5 - 1 : 0;

    this.magiBracketFiveMin = data.Bracket5 ? data.Bracket5 : 0;
    this.magiBracketFiveMax = data.Bracket6 ? data.Bracket6 - 1 : 0;

    this.magiBracketSixMin = data.Bracket6 ? data.Bracket6 : 0;
    this.magiBracketSixMax= 'more';

    this.magiBrackets = [
      {
        "value": "1",
        "bracket": '$' + this.magiBracketOneMin.toLocaleString()  + ' to '+ '$' + this.magiBracketOneMax.toLocaleString()
      },
      {
        "value": "2",
        "bracket": '$' + this.magiBracketTwoMin.toLocaleString()  + ' to '+ '$' + this.magiBracketTwoMax.toLocaleString()
      },
      {
        "value": "3",
        "bracket": '$' + this.magiBracketThreeMin.toLocaleString()  + ' to '+ '$' + this.magiBracketThreeMax.toLocaleString() 
      },
      {
        "value": "4",
        "bracket": '$' + this.magiBracketFourMin.toLocaleString()  + ' to '+ '$' + this.magiBracketFourMax.toLocaleString() 
      },
      {
        "value": "5",
        "bracket": '$' + this.magiBracketFiveMin.toLocaleString()  + ' to '+ '$' + this.magiBracketFiveMax.toLocaleString() 
      },
      {
        "value": "6",
        "bracket": '$' + this.magiBracketSixMin.toLocaleString()  + ' to '+ '$' + this.magiBracketSixMax.toLocaleString()
      },
    ]

    if (scenario == 'firstTimeLoad') {
      this.selectionDropDown.controls['magiBracket'].setValue(1);
    }

  }

  tabSelected = new FormControl(0);
  runReportWithSpouse(event){
    //toggle the display of the tabs
    this.profileInfo.controls['runReportWithSpouse'].setValue(!this.profileInfo.value.runReportWithSpouse);
    
    //if true, we need to move the user to the first tab for calcs
    if(this.profileInfo.value.runReportWithSpouse){
      this.tabSelected.setValue(0);
    }
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange(0);
    this.fundingTableCount();
  }

  public futureTotalCost: number;

  public sample: any = {
    ExpenseProjectionBody: "",
    FrmIncome: "",
    FullHorizonYears: "",
    FundingOptions: {},
    Illustrations: [],
    IncomeCompareAnalysis: {},
    P1Age: "",
    P1FullHorizonYears: "",
    P1Gender: "",
    P1HealthCareExpenses: "",
    P1HealthCareExpensesDiscounted: "",
    P1LifeTimeTotalsForComparison: "",
    P2Age: "",
    P2FullHorizonYears: "",
    P2Gender: "",
    P2HealthCareExpenses: "",
    P2HealthCareExpensesDiscounted: "",
    P2LifeTimeTotalsForComparison: "",
    PlanUntil1: "",
    PlanUntilYear: "",
    RetireYear: null,
    RetirementYear: 0,
    State: "",
    TotalProjectedCost: "",
    TotalProjectedCostPv: "",
    TotalYear1Cost: "",
    TotalYear1OOP: "",
    TotalYear1Premiums: "",
    YearOneTotal: "",
    YearsInRetirement: "",
    YearsToRetirement: "",
    hq: null,
    partners: null
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  public investmentOption: number = 1;
  currentYear = new Date().getFullYear();
  clientIndex = 0;
  spouseIndex = 0;
  spouseRetirementYear: number = 0;

  getHCData(client: any, includeSpouse?: any) {
    this.loadingService.isLoading(true);

    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    var spouse = {};

    var investmentItems = [];

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        Ends: this.fundingItems[item].endAge,
        StartAmount: this.fundingItems[item].annContribution,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    if (this.client.clientProfile.Spouses
      && this.client.clientProfile.Spouses.length > 0
      && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      this.partnerActive = true;
    } else {
      this.partnerActive = false;
    }

    //let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
    let spouseDOB = "";
    if(this.getSpouseProfileInfo){
      spouseDOB = ((new Date(this.getSpouseProfileInfo.dob).getMonth()) + 1) + '/' + new Date(this.getSpouseProfileInfo.dob).getDate() + '/' + new Date(this.getSpouseProfileInfo.dob).getFullYear() + ' 00:00:00';
    }

    var HCReport = {
      InvestmentItems: JSON.stringify({ investmentItems }),
      P_Part_A_And_B: this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: 0,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQDCW: this.client.clientProfile.HCDCW,
      FrmQMS: this.client.clientProfile.HCMS,

      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,

      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      // FrmPlanUntil: 0,
      // FrmPlanUntil0: 0,
      // FrmPlanUntil1: 0,
      // SpouseFrmPlanUntil: 0,
      selfConditions: JSON.stringify({
        HCHBP: this.client.clientProfile.HCHBP,
        HCHC: this.client.clientProfile.HCHC,
        HCT2D: this.client.clientProfile.HCT2D,
        HCCD: this.client.clientProfile.HCCD,
        HCC: this.client.clientProfile.HCC,
        HCT: this.client.clientProfile.HCT,

        HCALZ: this.client.clientProfile.HCALZ,
        HCPARK: this.client.clientProfile.HCPARK,
        HCAMP: this.client.clientProfile.HCAMP,
        HCPTSD: this.client.clientProfile.HCPTSD,
        HCOBS: this.client.clientProfile.HCOBS,
      }),

      spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
        HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
        HCHC: this.client.clientProfile.Spouses[0].HCHC,
        HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
        HCCD: this.client.clientProfile.Spouses[0].HCCD,
        HCC: this.client.clientProfile.Spouses[0].HCC,
        HCT: this.client.clientProfile.Spouses[0].HCT,

        HCALZ: this.client.clientProfile.Spouses[0].HCALZ,
        HCPARK: this.client.clientProfile.Spouses[0].HCPARK,
        HCAMP: this.client.clientProfile.Spouses[0].HCAMP,
        HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD,
        HCOBS: this.client.clientProfile.Spouses[0].HCOBS,
      }) : "",

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,

      PaymentTotal: 0,
      PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,

      // FrmIncome: 'Ind1',

      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      FrmPV: this.FrmPV,
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
      HouseholdYearOneIncome: 0,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
      SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
      InvestmentOption: this.investmentOption || 1,
      ClientPIA: this.client.clientProfile.PIA,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,

      Bracket: this.client.clientProfile.Bracket,//(!this.client.clientProfile.CurrentIncome) ? this.client.clientProfile.Bracket : null,
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,

      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      SelfDOB: this.client.client.DOB,
      SpouseDOB: spouseDOB,
      PreRetirementInflationRate: 0.03,
      InRetirementInflationRate: 0.03,
      SelfSupplementalPlan: "G",
      SpouseSupplementalPlan: "G",

      SelfRetirementAge: this.client.clientProfile.RetirementAge,//this.retirementAge,
      //IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),
      // SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
      SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].retirementAge : 0,//this.spouseRetirementAge,
      //IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),
      CoverageType: this.client.clientProfile.CoverageType,//this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: this.client.clientProfile.CoverageType1,//(this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: this.client.clientProfile.PrivateInsurance,//this.profileInfo.value.privateHealthInsurance || false,
      PrivateInsurance1: this.client.clientProfile.PrivateInsurance1,//(this.partnerActive) ? this.spouseProfileInfo.value.privateHealthInsurance || false : false,

    }

    if (includeSpouse){      
      this.client.clientProfile.Spouses[0].dob = spouseDOB;
      spouse = client.clientProfile.Spouses[0];
      console.log('spouse', spouse);
    }

    this.client.retirementState = this.client.state;

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }
    console.log("Result");
    console.log(HCReport);
    console.log(user);
    this.globalService.getHCDataV2(HCReport, user)
      .subscribe(
        data => {
          this.hcDataV2 = data;
          console.log('this.hcDataV2',this.hcDataV2);
          //this.onCheckBoxChange('client');
          if (this.partnerActive) {
            let date = new Date();
            let spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge);
            let spouseAge =  Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
            console.log('date.getFullYear()', date.getFullYear());
            console.log('spouseRetirementAge', spouseRetirementAge);
            this.spouseRetirementYear = Number(date.getFullYear()) + (spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge): 0);
            // spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge) : 0;
            //this.onCheckBoxChange('spouse');
          }
          this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);
          this.p1CostsV2 = JSON.parse(this.FrmPV == 0 ? data.P1HealthCareExpensesDiscounted : data.P1HealthCareExpenses);
          this.p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? data.P2HealthCareExpensesDiscounted : data.P2HealthCareExpenses) : {};
          this.tempCostsV2 = this.p1CostsV2;

          console.log('p1costsv2', this.p1CostsV2);

          /* if (this.p1CostsV2[0].Total == 0) {
            var tempCosts = [];

            for (var item in this.p2CostsV2) {
              if (this.p2CostsV2[item].Total != 0) {
                tempCosts.push(this.p2CostsV2[item]);
              }
            }

            this.p1CostsV2 = tempCosts;
          } */

          var clientIndex = 0;
          var spouseIndex = 0;
          

          this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
          //
          /* if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

            this.hcDataV2.RetirementYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
            this.hcDataV2.RetirementYear = Math.max(currentYear, this.hcDataV2.RetirementYear);

          } */

          // check index for client is spouse retires earlier
          if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            //this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
            if(this.spouseRetirementYear < this.hcDataV2.RetirementYear){
              clientIndex = (this.hcDataV2.RetirementYear - this.spouseRetirementYear);
              this.clientIndex = clientIndex;
              console.log('clientIndex', this.clientIndex);
            } else {
              spouseIndex = (this.spouseRetirementYear - this.hcDataV2.RetirementYear);
              this.spouseIndex = spouseIndex;
              console.log('spouseIndex', this.spouseIndex);
            }       
          }

          this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[clientIndex].AdditionalOOP[0] + this.p1CostsV2[clientIndex].AdditionalOOP[1] + this.p1CostsV2[clientIndex].AdditionalOOP[2] + this.p1CostsV2[clientIndex].AdditionalOOP[3]).toFixed(0));
          //this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0));//this.partnerActive ? (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3] + this.p2CostsV2[0].AdditionalOOP[0] + this.p2CostsV2[0].AdditionalOOP[1] + this.p2CostsV2[0].AdditionalOOP[2] + this.p2CostsV2[0].AdditionalOOP[3]).toFixed(0) : (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0);
          // this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0));//this.partnerActive ? (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3] + this.p2CostsV2[0].Premiums[0] + this.p2CostsV2[0].Premiums[1] + this.p2CostsV2[0].Premiums[2] + this.p2CostsV2[0].Premiums[3]).toFixed(0) : (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0);
          //this.hcDataV2.TotalYear1Premiums = (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0);
          this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[clientIndex].Premiums[0] + this.p1CostsV2[clientIndex].Premiums[1] + this.p1CostsV2[clientIndex].Premiums[2] + this.p1CostsV2[clientIndex].Premiums[3]).toFixed(0));
          this.hcDataV2.YearOneTotal = Utils.formatToCurrency((this.p1CostsV2[clientIndex].AdditionalOOP[0] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[1] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[2] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[3]
            + this.p1CostsV2[clientIndex].Premiums[0] 
            + this.p1CostsV2[clientIndex].Premiums[1] 
            + this.p1CostsV2[clientIndex].Premiums[2] 
            + this.p1CostsV2[clientIndex].Premiums[3]).toFixed(0));

            if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
              this.hcDataV2.RetireYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
              this.hcDataV2.RetireYear = Math.max(currentYear, this.hcDataV2.RetireYear);
  
              this.hcDataV2.TotalYear1OOP1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] + this.p2CostsV2[spouseIndex].AdditionalOOP[1] + this.p2CostsV2[spouseIndex].AdditionalOOP[2] + this.p2CostsV2[spouseIndex].AdditionalOOP[3]).toFixed(0));
              this.hcDataV2.TotalYear1Premiums1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].Premiums[0] + this.p2CostsV2[spouseIndex].Premiums[1] + this.p2CostsV2[spouseIndex].Premiums[2] + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));
              //console.log('13');      
              
              this.hcDataV2.YearOneTotal1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[1] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[2] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[3]
                + this.p2CostsV2[spouseIndex].Premiums[0] 
                + this.p2CostsV2[spouseIndex].Premiums[1] 
                + this.p2CostsV2[spouseIndex].Premiums[2] 
                + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));
            }

          //this.hcDataV2.IncomeCompareAnalysis = JSON.parse(this.hcDataV2.IncomeCompareAnalysis);
          //this.hcDataV2.IncomeCompareAnalysis.incomeCompareRows.shift();
          if(this.hcDataV2.IncomeCompareAnalysis != null){
            this.hcDataV2.IncomeCompareAnalysis = JSON.parse(this.hcDataV2.IncomeCompareAnalysis);
            this.hcDataV2.IncomeCompareAnalysis.incomeCompareRows.shift();
          }

          this.futureTotalCost = Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", ""));
          this.projectedFutureLifetimeCosts = Number(this.hcDataV2.TotalProjectedCostPv.toString().replace(/,/g, "").replace("$", ""));


          this.totalSocialSecurity = Number(this.hcDataV2.FundingOptions.PartB.toString().replace(/,/g, "").replace("$", ""));

          this.totalInvestment = this.totalSocialSecurity + this.additionalFunds;

          this.hcDataV2.Illustrations = JSON.parse(this.hcDataV2.Illustrations);


          this.totalRemainingGap = Number(this.hcDataV2.Illustrations[0].BeginningBalance); //Number(this.hcDataV2.FundingOptions.InvestmentAmountCoverage.toString().replace(",","").replace("$",""));

          // this.currentRemainingTotal = Utils.formatToCurrency(this.futureTotalCost - this.totalSocialSecurity);
          //this.currentRemainingTotal = this.futureTotalCost - this.totalSocialSecurity;
          this.currentRemainingTotal = this.futureTotalCost - this.totalInvestment;
          this.currentRemainingTotal = Number(this.currentRemainingTotal) < 0 ? 0: this.currentRemainingTotal;
          
          if (this.fundingItems.length > 0) {
            var tempTotal = this.futureTotalCost - this.totalSocialSecurity;

            for (var i = 0; i < this.fundingItems.length; i++) {
              this.fundingItems[i].remainingUnfunded = this.fundingItems[i - 1] ? this.fundingItems[i - 1].remainingUnfunded - this.fundingItems[i].contributionAmount : tempTotal - this.fundingItems[i].contributionAmount;
            }

          }
          // this.yearlyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0): this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount;
          this.yearlyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0: Utils.removeCurrencyFormatting(this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount);
          this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);
          // this.futureYearlyCost = this.annualEl ? this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * this.annualEl.nativeElement.value : this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * 10;
          // this.weeklyCost = Utils.formatToCurrency(this.annualEl ? Number(((Number(this.futureYearlyCost) / this.annualEl.nativeElement.value) / 52).toFixed(0)) : Number(((Number(this.futureYearlyCost) / 10) / 52).toFixed(0)));
          this.weeklyCost = this.annualEl ? Number(((Number(this.futureYearlyCost) / this.annualEl.nativeElement.value) / 52).toFixed(0)) : Number(((Number(this.futureYearlyCost) / 10) / 52).toFixed(0));
          // this.futureWeeklyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0) :Utils.removeCurrencyFormatting(this.hcDataV2.FundingOptions.CalcPayments.WeeklyPaymentAmount) * 52 * (this.annualEl ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10));
          this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear));
          console.log('futureYearlyCost',this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount);
          console.log('weekly amount', this.weeklyCost);
          // this.futureYearlyCost = Utils.formatToCurrency(this.futureYearlyCost);
          // this.beginningBalance = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0));
          this.beginningBalance = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0);


          //this.generateLineChartData({});
          //this.generatePieChartData();
          this.generateBarChartData();
          this.getInvestmentGrowthData();
          this.getMMTData();

        },
        error => this.error = <any>error);
  }

  // TODO: Make utility file
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  getAdvisorData() {
    this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
    .subscribe(
      advisor => {
        this.advisor = advisor;
        //this.getClient();
        this.calculateLifeExp(false);
      },
      error => this.error = <any>error);
  }

  getClient() {
    //values from questionnaire
    console.log('HCE client', this.getClientProfileInfo);
    console.log('HCE client health', this.getClientHealthInfo);
    console.log('HCE spouse', this.getSpouseProfileInfo);

    let coverageType = this.selectionDropDown.value.coverage;
    //this.getCurrentIncome();
    this.minLEAge = Math.min(this.selectionDropDown.value.lifeExpectancy, parseInt(this.selectionDropDown.value.retirementAge) + 1);
    this.maxLEAge = 100 - this.minLEAge + 1;
    
    let lifeExpectancy = this.selectionDropDown.value.lifeExpectancy;
    let retirementAge = this.selectionDropDown.value.retirementAge;
    let retirementState = this.selectionDropDown.value.retirementState;
    console.log(this.getClientProfileInfo);
    let spouses = [];
    if (this.getClientProfileInfo.maritalStatus) {
      spouses = [{
        PIAYears:{},
        maritalStatus:"Married",
        firstName:this.getSpouseProfileInfo.firstName,
        lastName:this.getSpouseProfileInfo.lastName,
        dob:this.getSpouseProfileInfo.dob,
        gender: Number(this.getSpouseProfileInfo.gender),
        LifeExpectancy:lifeExpectancy,
        retirementAge:retirementAge,
        state:retirementState,

        HCC: (this.getSpouseHealthInfo.cancer) ? 1 : 0,
        HCCD: (this.getSpouseHealthInfo.cardioDisease) ? 1 : 0,
        HCDCW: (this.getSpouseHealthInfo.depCaneWalker) ? 1 : 0,
        HCFHDC: (this.getSpouseHealthInfo.famHistory) ? 1 : 0,
        HCHBP: (this.getSpouseHealthInfo.highBP) ? 1 : 0,
        HCHC: (this.getSpouseHealthInfo.highChol) ? 1 : 0,
        HCMS: (this.getSpouseHealthInfo.multSclerosis) ? 1 : 0,
        HCT: (this.getSpouseHealthInfo.tobacco) ? 1 : 0,
        HCT1D: (this.getSpouseHealthInfo.type1Diab) ? 1 : 0,
        HCT2D: (this.getSpouseHealthInfo.type2Diab) ? 1 : 0
      }]

    } else {
      spouses = [{
        PIAYears: {},
        maritalStatus: "Single",
        pension: "",
        pia: "",
        previouslyMarried: false}]
    }
    
    let clientDOB = ((new Date(this.getClientProfileInfo.dob).getMonth()) + 1) + '/' + new Date(this.getClientProfileInfo.dob).getDate() + '/' + new Date(this.getClientProfileInfo.dob).getFullYear() + ' 00:00:00';
    let clientLocal = {
      DOB:  clientDOB,//this.getClientProfileInfo.dob,
      FirstName: this.getClientProfileInfo.firstName,
      GenderID: Number(this.getClientProfileInfo.gender),
      LastName: this.getClientProfileInfo.lastName,
      AdvisorID: this.advisor.ID
    };

    let clientProfile = {
      Bracket: this.selectionDropDown.value.magiBracket,
      Children: null,
      ClientMetroArea: null,
      //CoverageType: coverageType,
      CurrentIncome: 0,//this.currentIncome,

      HCC: (this.getClientHealthInfo.cancer) ? 1 : 0,
      HCCD: (this.getClientHealthInfo.cardioDisease) ? 1 : 0,
      HCDCW: (this.getClientHealthInfo.depCaneWalker) ? 1 : 0,
      HCFHDC: (this.getClientHealthInfo.famHistory) ? 1 : 0,
      HCHBP: (this.getClientHealthInfo.highBP) ? 1 : 0,
      HCHC: (this.getClientHealthInfo.highChol) ? 1 : 0,
      HCMS: (this.getClientHealthInfo.multSclerosis) ? 1 : 0,
      HCT: (this.getClientHealthInfo.tobacco) ? 1 : 0,
      HCT1D: (this.getClientHealthInfo.type1Diab) ? 1 : 0,
      HCT2D: (this.getClientHealthInfo.type2Diab) ? 1 : 0,

      IRR: 89,
      IncludePension: 0,
      InflationRate: 3,
      IsHSApplySpouse: false,
      //IsPrivHealthIns: (retirementAge < 65),
      IsRunReportWithSpouse: false,
      LifeExpectancy: lifeExpectancy,
      MaritalStatus: 1,
      OOPCosts: {HospitalAndTest: true, PrescriptionDrugs: true, HearingAndVisionCosts: true, DentalCosts: true},
      PIA: null,
      PIAYears: null,
      Pension: null,
      PensionMonths: null,
      PensionYears: null,
      PremiumType: "TM",
      Premiums: {MedicarePartB: true, MedicarePartD: true, SupplimentalInsurance: true, DentalInsurance: true},
      RequestFrom: null,
      
      RetirementAge: retirementAge,
      SelfRetirementAge: retirementAge,

      RetirementState: retirementState,
      //SpouseCoverageType: coverageType,//null,
      SpouseID: null,
      SpouseMetroArea: null,
      SpouseOOPCosts: {SpouseHospitalAndTest: true, SpousePrescriptionDrugs: true, SpouseHearingAndVisionCosts: true, SpouseDentalCosts: true},// "\"null\"",
      SpousePremiumType: "TM",
      SpousePremiums: {SpouseMedicarePartB: true, SpouseMedicarePartD: true, SpouseSupplemental: true, SpouseDentalInsurance: true},
      Spouses: spouses,
      SubstantialEarningYears: null,
      UseNationalAverage: (retirementState == 'NA') ? 1 : 0,

      CoverageType: coverageType == 'PPO' ? 0 : coverageType == 'HMO' ? 1 : 2,
      CoverageType1: (this.partnerActive) ? coverageType == 'PPO' ? 0 : coverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: (retirementAge < 65),//this.profileInfo.value.privateHealthInsurance || false,
      PrivateInsurance1: (this.partnerActive) ? (retirementAge < 65) : false //this.spouseProfileInfo.value.privateHealthInsurance || false : false,

    }
    console.log('this.client',this.client);
    this.client = {
      client: clientLocal,
      clientProfile: clientProfile
    }
    this.client.advisor = null;
    let dOB = new Date(this.client.client.DOB);
    let timeDiff = Math.abs(Date.now() - dOB.getTime());
    let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
    this.annuallyWeeklyTtlYear = this.client.clientProfile.RetirementAge - clientAge;
    this.client.clientProfile.Spouses = this.client.clientProfile.Spouses;

    if (this.client.clientProfile.Spouses.length > 1) {
      this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
    }

    if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married')
      this.partnerActive = true;
    else {
      this.partnerActive = false;
    }

    this.client.clientProfile.Children = this.client.clientProfile.Children;

    //reset premiums/OOPs as an object
    this.client.clientProfile.Premiums = this.client.clientProfile.Premiums;
    this.client.clientProfile.OOPCosts = this.client.clientProfile.OOPCosts;

    if(this.partnerActive){
      //reset premiums as an object
      this.client.clientProfile.SpousePremiums = this.client.clientProfile.SpousePremiums;
      this.client.clientProfile.SpouseOOPCosts = this.client.clientProfile.SpouseOOPCosts;

      this.spouseProfileInfo = new FormGroup({
        privateHealthInsurance: new FormControl(this.client.clientProfile.IsSpousePrivHealthIns),
        preRetirementCoverageType: new FormControl(this.client.clientProfile.SpouseCoverageType),
        inRetirementCoverageType: new FormControl(this.client.clientProfile.SpousePremiumType),

        //Traditional Medicare (TM)
        medicarePartB: new FormControl((this.client.clientProfile.SpousePremiumType == "STM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartB : false),
        medicarePartD: new FormControl((this.client.clientProfile.SpousePremiumType == "STM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartD : false),
        supplemental: new FormControl((this.client.clientProfile.SpousePremiumType == "STM") ? this.client.clientProfile.SpousePremiums.SpouseSupplemental : false),

        //Medicare Adv HMO
        medicareAdvHMO: new FormControl((this.client.clientProfile.SpousePremiumType == "SHMO") ? this.client.clientProfile.SpousePremiums.SpouseMedicareAdvHMO : false),

        //Medicare Adv PPO
        medicareAdvPPO: new FormControl((this.client.clientProfile.SpousePremiumType == "SPPO") ? this.client.clientProfile.SpousePremiums.SpouseMedicareAdvPPO : false),

        //always avail
        // dental: new FormControl(this.client.clientProfile.SpousePremiums.Dental),
        // hospitalDocsTestsOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts.HospitalAndTest),
        // prescriptionDrugsOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts.PrescriptionDrugs),  
        // hearingVisionOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts.HearingVision),    
        // dentalOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts.Dental),   
        //TODO: need to save this new value
        runReportWithSpouse: new FormControl(this.client.clientProfile.IsHSApplySpouse),
        maritalStatus: new FormControl()
      }); 
    } 

    //get healthcare data
    this.getHCData(this.client, this.partnerActive);
  }

  getCurrentIncome() {
    this.currentIncome = 0;
    if (this.selectionDropDown.value.magiBracket == 1) {
      this.currentIncome = this.magiBracketOneMax - 1;
    }
    if (this.selectionDropDown.value.magiBracket == 2) {
      this.currentIncome = this.magiBracketTwoMax - 1;
    }
    if (this.selectionDropDown.value.magiBracket == 3) {
      this.currentIncome = this.magiBracketThreeMax - 1;
    }
    if (this.selectionDropDown.value.magiBracket == 4) {
      this.currentIncome = this.magiBracketFourMax - 1;
    }
    if (this.selectionDropDown.value.magiBracket == 5) {
      this.currentIncome = this.magiBracketFiveMax - 1;
    }
    if (this.selectionDropDown.value.magiBracket == 6) {
      this.currentIncome = this.magiBracketSixMin + 1;
    }

  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  formatNumber2(amount) {
    amount = amount.toFixed(0);
    return Utils.formatToCurrency(amount);
  }

  createClient() {
    let lifeExpectancy =  this.selectionDropDown.value.lifeExpectancy;
    let retirementAge = this.selectionDropDown.value.retirementAge;
    let rettirementState = this.selectionDropDown.value.retirementState;

      var UserModel = {
        AdvisorID: this.advisor.ID,
        OrganizationID:this.advisor.OrganizationID,
        ID: 0,
        Username: '',
        Email: '',
        FirstName: this.getClientProfileInfo.firstName,
        LastName: this.getClientProfileInfo.lastName,
        Address: '',
        City: '',
        State: '',
        Zip: '',
        Phone: '',
        DOB: this.getClientProfileInfo.dob,
        GenderID: Number(this.getClientProfileInfo.gender),
      }
  
      var spouses = [];

      if (this.getClientProfileInfo.maritalStatus) {
        spouses[0] = { PIAYears: {} };
        spouses[0].maritalStatus = 'Married';
        spouses[0].firstName = this.getSpouseProfileInfo.firstName;
        spouses[0].lastName = this.getSpouseProfileInfo.lastName;
        spouses[0].dob = this.getSpouseProfileInfo.dob;
        spouses[0].gender = Number(this.getSpouseProfileInfo.gender);
        spouses[0].LifeExpectancy = lifeExpectancy
        spouses[0].retirementAge = retirementAge;
        spouses[0].state = rettirementState;
        spouses[0].HCT2D = 0;
        spouses[0].HCHBP = 0;
        spouses[0].HCC = 0;
        spouses[0].HCHC = 0;
        spouses[0].HCCD = 0;
        spouses[0].HCT = 0;
        spouses[0].HCT1D = 0;
        spouses[0].HCMS = 0;
        spouses[0].HCDCW = 0;
        spouses[0].HCFHDC = 0;
      } else {
  
        //TODO: need to allow looping of profiles in the API when in this ELSE
        spouses[0] = { PIAYears: {} };
        spouses[0].maritalStatus = 'Single';
        spouses[0].pia = '';
        spouses[0].pension = '';
        spouses[0].previouslyMarried = false;
      }
  
      var ClientProfile = {
        RetirementAge: retirementAge,
        UseNationalAverage: 0,
        RetirementState: rettirementState,
        HCHBP: 0,
        HCHC: 0,
        HCT2D: 0,
        HCCD: 0,
        HCC: 0,
        HCT: 0,
        HCT1D: 0,
        HCMS: 0,
        HCDCW: 0,
        HCFHDC: 0,
        Spouses: JSON.stringify(spouses),
        IncludePension: 0,
        LifeExpectancy: lifeExpectancy,
        IsRunReportWithSpouse: this.getClientProfileInfo.maritalStatus,
        IsLegalSpouse: this.getClientProfileInfo.maritalStatus ? true: null,
      }
      
      var RiskTolerance = null;
  
      console.log('SaveClient', ClientProfile);
  
      if (true) { // validate fields again?
        this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
          .subscribe(
            resp => {
              console.log('create user', resp)
              if (resp.type != 0) {
                if (!this.client.clientProfile) {
                  this.globalService.getClientsData()
                    .subscribe(
                      clients => {
                        UserModel.ID = resp.message;
                        this.snackBarService.add('To create a report for ' + UserModel.FirstName + ' ' + UserModel.LastName + ', please click ', 0, 1, 10000);
  
                      },
                      error => {
                        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                        this.error = <any>error;
  
                      });
                } else {
                  this.snackBarService.add('Client has been updated', 0);
  
                }
  
                localStorage.setItem('selectedClient', resp.message);
                this.router.navigate(['reports/new']);
  
                this.snackBarService.add('Successfully create the client.', 1);
  
              } else {
                this.snackBarService.add('An error occured creating this client.', 1);
              }
  
            },
            error => {
              this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
              this.error = <any>error;
  
            });
  
      } else {
        //this.snackBarService.add('Please make sure all fields are properly filled out', 1);
      }
  }

  handleSavingHC() {
    var Report = {
      ClientID: 0,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: localStorage.getItem('orgID'),
      ReportTypeID: 3,
    }
    console.log('company code');
    console.log(localStorage.getItem('advisor'));
    // console.log(localStorage.getItem('orgID'));
    // console.log(localStorage.getItem('roleId'));
    // console.log(localStorage.getItem('selectedAdvisorOrgID'));
    // this.modalData = localStorage.getItem('advisor');
    // if (this.modalData) {
    //   this.modalData = JSON.parse(localStorage.getItem('advisor'));
    // }

    var investmentItems = [];

    var investmentItem;

    var currentAge = this.calculateAge(this.client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
        // ContributionType: 0,
      }

      investmentItems.push(contribution);
    }

    let spouseDOB = "";
    if(this.getSpouseProfileInfo){
      spouseDOB = ((new Date(this.getSpouseProfileInfo.dob).getMonth()) + 1) + '/' + new Date(this.getSpouseProfileInfo.dob).getDate() + '/' + new Date(this.getSpouseProfileInfo.dob).getFullYear() + ' 00:00:00';
    }

    var ReportHC = {
      // ID: 0,
      InvestmentItems: JSON.stringify({ InvestmentItems: { Items: investmentItems } }),
      P_Part_A_And_B: this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: 0,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      FrmPlanUntil: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil1: this.hcDataV2.PlanUntil1,
      SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCBP ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: 0,
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,

      PaymentTotal: 0,
      PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,

      FrmIncome: this.hcDataV2.FrmIncome,

      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      FrmPV: this.FrmPV,
      FrmRetireYear0: this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB),
      FrmState: this.client.clientProfile.RetirementState,
      FundCosts: this.futureTotalCost,

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,
      InvestmentOption: this.investmentOption || 1,
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

      HouseholdYearOneIncome: 0,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,

      SelfDOB: this.client.client.DOB,
      SpouseDOB: spouseDOB,
      PreRetirementInflationRate: 0.03,
      InRetirementInflationRate: 0.03,
      SelfSupplementalPlan: "G",
      SpouseSupplementalPlan: "G",

      SelfRetirementAge: this.client.clientProfile.RetirementAge,//this.retirementAge,
      //IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),
      // SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
      SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].retirementAge : 0,//this.spouseRetirementAge,
      //IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),
      CoverageType: this.client.clientProfile.CoverageType,//this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: this.client.clientProfile.CoverageType1,//(this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: this.client.clientProfile.PrivateInsurance ? 1 : 0,//this.profileInfo.value.privateHealthInsurance || false,
      PrivateInsurance1: this.client.clientProfile.PrivateInsurance1 ? 1 : 0,//(this.partnerActive) ? this.spouseProfileInfo.value.privateHealthInsurance || false : false,

      
    }
    // var ReportHC = {
    //   InvestmentItems: JSON.stringify({ InvestmentItems: { Items: investmentItems } }),
    //   P_Part_A_And_B: this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
    //   P_Part_D: this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
    //   P_MediGap: this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
    //   P_Dental: this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
    //   OOP_Hosp_Docs: this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
    //   OOP_Presc_Drug: this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
    //   OOP_Hearing_Vision: this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
    //   OOP_Dental: this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
    //   FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
    //   FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
    //   FrmHasPartner: this.partnerActive,
    //   FrmQType: 1,
    //   FrmQExcercise: 1,
    //   FrmGender: this.client.client.GenderID,
    //   FrmQTypeII: this.client.clientProfile.HCT2D,
    //   FrmQTobacco: this.client.clientProfile.HCT,
    //   FrmQCancer: this.client.clientProfile.HCC,
    //   FrmQHistory: 0,
    //   FrmQCardio: this.client.clientProfile.HCCD,
    //   FrmQPhysical: 1,
    //   FrmQHighColesterol: this.client.clientProfile.HCHC,
    //   FrmQDiet: 1,
    //   FrmQHBP: this.client.clientProfile.HCHBP,
    //   FrmCurrentAge: this.calculateAge(this.client.client.DOB),

    //   FrmPlanUntil: this.hcDataV2.PlanUntilYear,
    //   FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
    //   FrmPlanUntil1: this.hcDataV2.PlanUntil1,
    //   SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1,
      
    //   selfConditions: JSON.stringify({
    //     HCHBP: this.client.clientProfile.HCHBP,
    //     HCHC: this.client.clientProfile.HCHC,
    //     HCT2D: this.client.clientProfile.HCT2D,
    //     HCCD: this.client.clientProfile.HCCD,
    //     HCC: this.client.clientProfile.HCC,
    //     HCT: this.client.clientProfile.HCT,
    //   }),

    //   spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
    //     HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
    //     HCHC: this.client.clientProfile.Spouses[0].HCHC,
    //     HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
    //     HCCD: this.client.clientProfile.Spouses[0].HCCD,
    //     HCC: this.client.clientProfile.Spouses[0].HCC,
    //     HCT: this.client.clientProfile.Spouses[0].HCT,
    //   }) : "",

    //   SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
    //   SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

    //   SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
    //   SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
    //   SpouseFrmQDiet: 1,
    //   SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
    //   SpouseFrmQPhysical: 1,
    //   SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
    //   SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
    //   SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
    //   SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
    //   SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
    //   SpouseQExcercise: 1,
    //   SpouseQHistory: 0,

    //   PaymentTotal: 0,
    //   PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,

    //   FrmIncome: this.currentIncome.toString(),

    //   FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
    //   FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
    //   FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
    //   FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
    //   FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

    //   FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob) : 0,
    //   FrmPV: this.FrmPV,
    //   FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
    //   FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
    //   SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
    //   SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
    //   SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
    //   InvestmentOption: this.investmentOption || 1,
    //   ClientPIA: this.client.clientProfile.PIA,
    //   SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
    // }

    console.log('ReportHC', ReportHC);
    this.globalService.createReportHC(Report, ReportHC)
      .subscribe(
        resp => {
          this.snackBarService.add("Please wait while your healthcare report is being generated.", 0);

          this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
        },
        error => this.error = <any>error);
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };

    this.globalService.generateReport(ReportFields, this.client.client, ReportFields, false, true)
      .subscribe(
        resp => {;
          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error;
          this.loadingService.isLoading(false);
        });
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  formatPercent(percentage) {
    return (percentage * 100).toFixed(0);
  }

  addFunds: boolean;
  //rateControl = new FormControl("", [Validators.max(100), Validators.min(0)])
  handleNewFundingItem(fundingSource: string, annContribution: any, startAge: number, endAge: number, inflationRate: number) {

    this.addFunds = true;

    //check year here
    if (startAge < this.currentYear) {
      startAge = this.currentYear;
    }

    if (endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear) {
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }

    annContribution = Utils.formatToNumber(annContribution)
    var contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);

    this.totalRemainingGap = this.formatNumber((this.totalRemainingGap - Number(contributionAmount)));

     /* if (Number(this.totalRemainingGap) >= 0 ) {
       this.animateValue(this.totalRemainingGapEl, 0, this.roundAndFormat(this.totalRemainingGap, 0));
     } else {
       this.animateValue(this.totalRemainingGapEl, 0, { shortValue: 0, suffix: ''});
     } */

    //this.ssRemaining = this.totalRemainingGap;

    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });


    /* this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = ''; */


    this.getHCData(this.client, this.partnerActive);
    // this.generatePieChartData();
    // this.generateBarChartData();
  }

  getFutureValue(startAmount, years, inflation) {
    inflation = inflation / 100;
    var total = 0;


    for (var i = 0; i <= years; i++) {
      total = total + startAmount * Math.pow(1 + inflation, i);
    }

    return total;
  }

  getFutureValueOfCost(startAmount, years, inflation) {
    return startAmount * Math.pow(1 + inflation, years);
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  getFutureContributionAmount(startAmount, years, inflation, startAge, idx) {
    var startingBalance = 0;
    var interestEarned = 0;
    var contribution = Number(startAmount);
    var endingBalance = Number(startAmount);
    startAge = Number(startAge);

    for (let i = 0; i < years; i++) {
      if (startAge + i <= this.p1EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p1Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else if (startAge + i <= this.p2EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p2Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p3Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      }
    }

    if (idx != null) {
      // this.fundingItems[idx].annContribution = endingBalance;
      this.fundingItems[idx].remainingUnfunded = Number(this.totalRemainingGap - endingBalance).toFixed(0);
      this.fundingItems[idx].contributionAmount = Number(endingBalance).toFixed(0);
    }

    return Number(endingBalance).toFixed(0);
  }

  onRateChange(percentValue) {

    //get HC data
    this.getHCData(this.client, this.partnerActive);

    //check value
    if (percentValue != undefined) {
      if (percentValue.value > 12) {
        //percentValue.id 
        return percentValue.value = 12;
      }
    }
  }

  public visible: boolean = true;

  calculateCoverageTotal(el?: any, amount?: number, isPremium?: boolean, coverageKeyName?: string[]) {

    this.visible = true;
    this.getHCData(this.client, this.partnerActive);

    this.coverageTotal = el ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

    if (isPremium)
      this.premiumCoverageTotal = el ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
    else
      this.outOfPocketCoverageTotal = el ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

    this.generateLineChartData({});

/*     this.premiumExpenses = {
      partB: this.hdt.nativeElement.checked,
      partD: this.pd.nativeElement.checked,
      medigap: this.si.nativeElement.checked,
      dental: this.di.nativeElement.checked
    };

    this.outOfPocketExpenses = {
      hospitalization: this.hd.nativeElement.checked,
      docsTests: this.hd.nativeElement.checked,
      rx: this.pdrg.nativeElement.checked,
      dental: this.dins.nativeElement.checked,
      hearingServices: this.hvc.nativeElement.checked,
      vision: this.hvc.nativeElement.checked,
      commercial: true
    };



    if (
      !this.premiumExpenses.partB &&
      !this.premiumExpenses.partD &&
      !this.premiumExpenses.medigap &&
      !this.premiumExpenses.dental &&
      !this.outOfPocketExpenses.hospitalization &&
      !this.outOfPocketExpenses.docsTests &&
      !this.outOfPocketExpenses.rx &&
      !this.outOfPocketExpenses.dental &&
      !this.outOfPocketExpenses.hearingServices &&
      !this.outOfPocketExpenses.vision
    ) {
      this.visible = false;
      this.hcDataV2 = this.sample;

    } else {
      this.visible = true;
      this.getHCData(this.client, this.partnerActive);

      this.coverageTotal = el.checked ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

      if (isPremium)
        this.premiumCoverageTotal = el.checked ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
      else
        this.outOfPocketCoverageTotal = el.checked ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

      this.generateLineChartData({});
    }
 */

  }

  animateValue(el, start, formattedNumber): void {
    var end = parseFloat(formattedNumber.shortValue);
    var current = start;
    var increment = start < 0 ? -1 : 1;
    var stepTime = Math.abs(1);

    if (formattedNumber.shortValue > 0) {
      el.nativeElement.innerHTML = `$${end.toFixed(2)}${formattedNumber.suffix || ''}`;

      // var timer = setInterval(function () {

      //   if (Math.abs(current - end) < 5) {
      //     increment = start < 0 ? -0.1 : 0.1;
      //   }

      //   current += increment;
      //   el.nativeElement.innerHTML = `$${current.toFixed(2)}${formattedNumber.suffix || ''}`;

      //   if (current.toFixed(2) == end.toFixed(2)) {
      //     clearInterval(timer);
      //   }
      // }, stepTime);
    } else {
      el.nativeElement.innerHTML = `$0`;
    }
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
      c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  public weeklyCost: Number = 0;
  public yearlyCost: Number = 0;

  public futureYearlyCost: Number = 0;
  public futureWeeklyCost: Number = 0;

  calcAnnualSavings(el, el2) {

    el2.value = el.value;
    // el.value = el2.value;getHCData

    this.getHCData(this.client, this.partnerActive);

    // this.futureYearlyCost = this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount * years.val;

    // var value = this.getFutureValueOfCost(this.totalRemainingGap, this.annualEl.nativeElement.value, 0.02);

    // var result = Number(value / this.annualEl.nativeElement.value).toFixed();

    // this.yearlyCost = Number(result).toFixed();
    // this.futureYearlyCost = value.toFixed();
    // return Number(result) < 0 ? 0 : result;
  }

  calcWeeklySavings(isAnnual) {
    if (isAnnual)
      this.weeklyEl.nativeElement.value = this.annualEl.nativeElement.value;
    else
      this.annualEl.nativeElement.value = this.weeklyEl.nativeElement.value;
    this.getHCData(this.client, this.partnerActive);

    // var value = this.getFutureValueOfCost(this.totalRemainingGap, this.weeklyEl.nativeElement.value, 0.02);
    // var result = Number(value / ((this.weeklyEl.nativeElement.value * 12) * 52)).toFixed();
    // this.weeklyCost = Number(result).toFixed();
    // this.futureWeeklyCost = value.toFixed();
    //return Number(result) < 0 ? 0 : result;
  }

  handleIllustrationModal(e) {
    var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
      return {
        Year: this.currentYear,
        BeginningBalance: Utils.formatToCurrency(entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
        ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%' : 0),
        // Premiums: '$' + 0,
        Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
        // AdditionalCosts: '$' + 0,
        Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
        NetOfSSDeductions: Utils.formatToCurrency(entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)),
        EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
      }
    });


    this.modalService.add('hc-projections', { Data: projectedYears });
  }

  investmentGrowthData;
  getInvestmentGrowthData(){
    //reset object array
    let isRetirementGreaterThanCurrent = false;
    this.investmentGrowthData = [];
    let currentYear = new Date().getFullYear();
    //let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;
    let retirementYearFromAPI = this.partnerActive ? (this.hcDataV2.RetireYear < this.hcDataV2.RetirementYear ? this.hcDataV2.RetireYear : this.hcDataV2.RetirementYear): this.hcDataV2.RetirementYear;
    let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : retirementYearFromAPI;

    //get values for graph
    var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
      return {
        Year: currentYear++,
        BeginningBalance: (entry.BeginningBalance ? parseInt(entry.BeginningBalance.toFixed(0)) : 0),
        //ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%' : 0),
        // Premiums: '$' + 0,
        //Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
        // AdditionalCosts: '$' + 0,
        //Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
        NetOfSSDeductions: (parseInt(entry.CashFlowEntry.Expense.toFixed(0)) - parseInt(entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0))),
        //EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
      }
    });

    var investmentGrowthDecumation = [];
    for(var i in projectedYears){
      if(projectedYears[i].Year < retirementYear){
        isRetirementGreaterThanCurrent = true;
        //pre-retirement
        investmentGrowthDecumation.push({        
          name: projectedYears[i].Year.toString(),
          series:[
            {
              name: "Investment Value, Pre-Retirement",
              value: projectedYears[i].BeginningBalance
            }
          ]
        });
      } else {
        //in-retirement
        /* investmentGrowthDecumation.push({        
          name: projectedYears[i].Year.toString(),
          series:[
            {
              name: "Annual Healthcare Spend",
              value: projectedYears[i].NetOfSSDeductions
            },
            {
              name: "Investment Value, In-Retirement",
              value: projectedYears[i].BeginningBalance
            }
          ]
        }); */
        investmentGrowthDecumation.push({
          name: projectedYears[i].Year.toString(),
          series: [
            {
              name: "Annual Net Healthcare Spend",
              value: projectedYears[i].NetOfSSDeductions
            },
            {
              name: "Investment Value, In-Retirement",
              value: Math.abs(projectedYears[i].BeginningBalance - projectedYears[i].NetOfSSDeductions)
            }
          ]
        });
      }
    }

    //console.log('graph stuff', projectedYears);
    console.log('graph stuff', investmentGrowthDecumation);
    this.investmentGrowthData = investmentGrowthDecumation;
    if (!isRetirementGreaterThanCurrent) {
      this.barVerticalStackedChartOption = {
        showXAxis: true,
        showYAxis: true,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
    
        showYAxisLabel: false,
    
    
        roundEdges: false,
        colorScheme: {
          //domain: ['#3385C5', '#E58931', '#20a59f']
          // domain: ['#5270ad', '#487879', '#63a49e']
          // domain: ['#63a49e', '#5270ad','#487879']
          domain: ['#5270ad', '#487879','#487879']
        },
        autoScale: true
    
      };
    }
   
  }

  checkAllPremiums() {
    var enabled = this.pcheck.nativeElement.checked;

    this.hdt.nativeElement.checked = enabled;
    this.pd.nativeElement.checked = enabled;
    this.si.nativeElement.checked = enabled;
    this.di.nativeElement.checked = enabled;

    this.calculateCoverageTotal();

    //this.getHCData(this.client);
  }

  checkAllOOP() {
    var enabled = this.oopcheck.nativeElement.checked;

    this.hd.nativeElement.checked = enabled;
    this.hvc.nativeElement.checked = enabled;
    this.dins.nativeElement.checked = enabled;
    this.pdrg.nativeElement.checked = enabled;

    this.calculateCoverageTotal();
    //this.getHCData(this.client);
  }

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.getHCData(this.client);
  }

  valueToggle(e) {
    this.FrmPV = e;//Number(e.target.value);
    this.getHCData(this.client, this.partnerActive);
  }

  spouseToggle(e) {    
    this.spouseHC = e;
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val));
  }

  formatNumber3(val) {

    return Utils.formatToNumber(val);
  }

  formatNumber4(val1) {

    return Utils.formatToNumber(val1);
  }


  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
      this.showAnnContrBorder = false;
    } else {
      this.showAnnContrBorder = true;
    }

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }
  }

  fundingTableCount() {
    this.fundingItems;
    let count = this.fundingItems.length 
    if (count >= 1) {
      this.showTable = true;
    } else {
      this.showTable = false;      
    }
  }

  fundingSourceModal(modalName): void {
    const dialogRef = this.dialog.open(FundingSourceComponent, {
      width: '1000px',
      height: '700px',
      data: { client: this.client, hcDataV2: this.hcDataV2, modalName: modalName }
    });

    dialogRef.afterClosed().subscribe(result => {

      this.fundingItems.push(result.data);
      this.fundingTableCount();

    });
  }

  returnedAdjustStartInvestment(data){
    console.log('data', data);
    console.log('from funding year dropdown', data.selectedBalance);
    if(data.isWeekly){
      this.weeklyCost = data.selectedBalance;
      this.bodyCardSelectedIndexWeekly = data.selectedDropDownIndex;
    } else {
      this.yearlyCost = data.selectedBalance;
      this.bodyCardSelectedIndexAnnually = data.selectedDropDownIndex;
    }
    // this.bodyCardSelectedIndex = data.selectedDropDownIndex;
  }

  formatName() {
    if (this.client) {
      return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
        this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
        : this.client.client.FirstName + ' ' + this.client.client.LastName
    }
  }

  AddFundingSource() {
    
  }

  toggleSpouseHC() {
    this.spouseHCOptionsVisible = !this.spouseHCOptionsVisible;
  }

  toggleDuration() {
    this.FrmPV = this.FrmPV == 0 ? 1 : 0;
    this.getHCData(this.client, this.partnerActive);
  }

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  selectInvestmentOption(option) {
    this.investmentOptionValue = option;
  }

  bodyCardSelection(scenario) {
    console.log('bodyCardSelection');
    console.log(scenario);
    this.selected.isoneTimeInvestmentSelect = false;
    this.selected.isannuallyRecurringInvestmentSelect = false;
    this.selected.isweeklyRecurringInvestmentSelect = false;
    if (scenario == 'isoneTimeInvestmentSelect') {
      this.selected.isoneTimeInvestmentSelect = true;
      // this.investmentDescription = "test"
    }
    if (scenario == 'isannuallyRecurringInvestmentSelect') {
      // let bodyCardSelectedIndex = (this.bodyCardSelectedIndex ? this.bodyCardSelectedIndex : this.dropDownSelectedIndex).toString();
      let dropDownSelectedIndex = this.dropDownSelectedIndexAnnually ? this.dropDownSelectedIndexAnnually :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexAnnually? this.bodyCardSelectedIndexAnnually : dropDownSelectedIndex).toString();
      this.investmentDescription = "Annually for " + bodyCardSelectedIndex + " years"
      this.selected.isannuallyRecurringInvestmentSelect = true;
    }
    if (scenario == 'isweeklyRecurringInvestmentSelect') {
      let dropDownSelectedIndex = this.dropDownSelectedIndexWeekly ? this.dropDownSelectedIndexWeekly :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexWeekly? this.bodyCardSelectedIndexWeekly : dropDownSelectedIndex).toString();
      this.investmentDescription = "Weekly for " + bodyCardSelectedIndex + " years"
      this.selected.isweeklyRecurringInvestmentSelect = true;
    }

  }

  formatDataLabel(value)
  {
    return Utils.formatToCurrency(value);
    //return "$" + value
  }
  
  calculateLifeExp(isSpouse){
    var LEObject;
    var profileInfo = (isSpouse) ? this.getSpouseProfileInfo : this.getClientProfileInfo; 
    var healthInfo = (isSpouse) ? this.getSpouseHealthInfo : this.getClientHealthInfo;
  
    console.log('le profile', profileInfo);
    LEObject = {
      gender: Number(profileInfo.gender),
      age: this.calculateAge(profileInfo.dob),
      healthConditions: {

        HCC: (healthInfo.cancer) ? 1 : 0,
        HCCD: (healthInfo.cardioDisease) ? 1 : 0,
        HCDCW: (healthInfo.depCaneWalker) ? 1 : 0,
        HCFHDC: (healthInfo.famHistory) ? 1 : 0,
        HCHBP: (healthInfo.highBP) ? 1 : 0,
        HCHC: (healthInfo.highChol) ? 1 : 0,
        HCMS: (healthInfo.multSclerosis) ? 1 : 0,
        HCT: (healthInfo.tobacco) ? 1 : 0,
        HCT1D: (healthInfo.type1Diab) ? 1 : 0,
        HCT2D: (healthInfo.type2Diab) ? 1 : 0,

        HCCYrsDiag: 0,//healthInfo.value.cancerYearsDiagnosed,
        HCCDYrsDiag: 0,//healthInfo.value.cardioDiseaseYearsDiagnosed,
  
      }
    }
  
    console.log('LEObject',LEObject);
          
    //this will just set/patch the existing form that is set for client or spouse when called
    this.globalService.getLE(LEObject)
      .subscribe(
        le => {      
          this.selectionDropDown.patchValue({ lifeExpectancy: parseInt(le) });
          
          // check life expectancy is lesser than retirement age
          //const convertAge = new Date(profileInfo.value.dob);
          //const timeDiff = Math.abs(Date.now() - convertAge.getTime());
          //this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
  
          this.minLEAge = Math.min(parseInt(le), 65 + 1);//this.showAge);  
          this.maxLEAge = 100 - this.minLEAge + 1;

          //need to run LE first, then get clinet info
          this.getClient();  
        },
        error => { this.error = <any>error; });
  }

  mmtModalData;
  public ssClientAge: string = '65';
  public ssSpouseAge: string = '65';
  public ssClientAgeChanged: Subject<string> = new Subject<string>();
  public ssSpouseAgeChanged: Subject<string> = new Subject<string>();
  startingIllustration;
  mmtTotalSurcharges;
  getMMTData() {
        
    var tempReportVals = {
        InflationRate: 0.03,
        //MagiIncomePercent: this.magi,
        IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
        SocialSecurityRetirementAge: this.ssClientAge,
        SSMonthlyBenefit: this.client.clientProfile.PIA,
        PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
        PartnerSocialSecurityAge: this.ssSpouseAge
    }

    var user = {
        UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
        CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
        ClientID: localStorage.getItem('selectedClient')
    }

    if ((Number(this.ssClientAge) >= 60 || Number(this.ssClientAge) <= 70) && (Number(this.ssSpouseAge) >= 60 || Number(this.ssSpouseAge) <= 70)) {
        
        this.globalService.getMMTData(this.client, tempReportVals, user)
            .subscribe(
                data => {
                    //this.createIRMAAAreaChartData(data);
                    //this.createIRMAALineChartData(data);
                    //this.calculateTotals(data);
                    this.startingIllustration = data.IllustrationEntries;
                    
                    //this.clientBenefit = Util.formatToCurrency(Number(data.clientSSBenfit / 12).toFixed(0) || 0);
                    //this.spouseBenefit = Util.formatToCurrency(Number(data.spouseSSBenefit / 12).toFixed(0) || 0);

                    this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                      if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                            //this.mmtData = data;

                            entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                            if (entry.PartnerAge)
                                entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;

                            let updatedEntry = {
                                yearWithAge: entry.PartnerAge ? `${entry.Year}(${entry.ClientAge}/${entry.PartnerAge})` : `${entry.Year} (${entry.ClientAge})`,
                                //magi: this.magi,
                                fullMAGI: this.formatCurrency(entry.HouseholdIncome),
                                percentMAGI: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                                updatedBracket: entry.MagiAdjustedIncomeBracket,
                                premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0]),
                                surcharges: this.formatCurrency(entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]),
                                total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                                savings: this.formatCurrency(Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0]))))
                            }

                            updatedEntry.total = this.formatCurrency(updatedEntry.total);
                            return updatedEntry;
                        }
                    });

                    const totalPremiums = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.premiums) } else { return r }}, 0));
                    const totalSurcharges = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.surcharges); } else { return r }}, 0));
                    const total = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.total) } else { return r }}, 0));
                    const savings = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.savings) } else { return r }}, 0));

                    this.mmtModalData.push({
                        yearWithAge: 'Total',
                        magi: '',
                        fullMAGI: '',
                        percentMAGI: '',
                        updatedBracket: '',
                        premiums: totalPremiums,
                        surcharges: totalSurcharges,
                        total: total,
                        savings: savings,
                    })

                    this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
                  
                    this.mmtTotalSurcharges = totalSurcharges;

                    this.loadingService.isLoading(false);
                },
                error => console.log(error));
    }
}
}
